import React from 'react';
import {
  Card,
  Button,
  IconSettings,
  ButtonGroup,
} from '@salesforce/design-system-react';

class Idea extends React.Component {
  state = {
    isEdit: false,
    content: '',
  };
  static defaultProps = {
    headerActions: true,
    personas: false,
  };

  /**
   * IDEA FUNCTIONS
   */
  onIdeaSelect = (evt) => {
    if (this.props.personas) {
      // Persona
      this.props.onDropdownSelected(this.props.id, evt.value, evt.content || this.props.ideaContent, this.props.chosen, this.props.milestone);
    } else if (this.props.connectors) {
      // Connectors
      this.props.onDropdownSelected(this.props.id, evt.value, this.props.milestone + "Connector", this.props.ideaContent);
    } else {
      // Milestones
      this.props.onDropdownSelected(this.props.id, evt.value, evt.content || this.props.ideaContent, this.props.chosen);
    } 
  };

  /**
   * CONNECTOR FUNCTIONS
   */
  onConnectorAction = (evt) => {
    console.log(this.props.id, evt.value, this.props.connector.connectorName, this.props.ideaTitle, this.props.ideaContent)
    this.props.onDropdownSelected(this.props.id, evt.value, this.props.connector.connectorName, this.props.ideaTitle, this.props.ideaContent);
  };

  getHeaderActions = () => {
    let headerActions;
    
    if (this.props.connector) {
      // milestone connector actions
      headerActions = (
        <ButtonGroup>
          <Button
            assistiveText={{ icon: 'edit' }}
            iconVariant="bare"
            className="slds-p-horizontal_x-small"
            variant="icon"
            iconCategory="utility"
            iconName="edit"
            disabled={this.state.isEdit}
            onClick={() => this.onConnectorAction({ value: 'Edit' })}
          />
          <Button
            assistiveText={{ icon: 'arrowup' }}
            iconVariant="bare"
            className="slds-p-horizontal_x-small"
            variant="icon"
            iconCategory="utility"
            iconName="arrowup"
            onClick={() => this.onConnectorAction({ value: 'Up' })}
          />
          <Button
            assistiveText={{ icon: 'arrowdown' }}
            iconVariant="bare"
            className="slds-p-horizontal_x-small"
            variant="icon"
            iconCategory="utility"
            iconName="arrowdown"
            onClick={() => this.onConnectorAction({ value: 'Down' })}
          />
          <Button
            assistiveText={{ icon: 'Delete' }}
            iconVariant="bare"
            className="slds-p-horizontal_x-small"
            variant="icon"
            iconCategory="utility"
            iconName="delete"
            style={{ color:'#b22222'}}
            onClick={() => this.onConnectorAction({ value: 'Delete' })}
          />
        </ButtonGroup>
      )
    } else {
      headerActions = (
        <ButtonGroup>
          <Button
            assistiveText={{ icon: 'edit' }}
            iconVariant="bare"
            variant="icon"
            iconCategory="utility"
            iconName="edit"
            disabled={this.state.isEdit}
            className="slds-p-horizontal_x-small"
            onClick={() => this.props.openEditIdea(this.props.id, this.props.ideaContent, this.props.milestone, this.props.chosen)}
          />
          <Button
            assistiveText={{ icon: 'favorite' }}
            iconVariant="bare"
            variant="icon"
            iconCategory="utility"
            iconName="favorite"
            className="slds-p-horizontal_x-small"
            onClick={() => this.onIdeaSelect({ value: 'Select' })}
          />
          <Button
            assistiveText={{ icon: 'Delete' }}
            iconVariant="bare"
            variant="icon"
            iconCategory="utility"
            iconName="delete"
            style={{ color:'#b22222'}}
            className="slds-p-horizontal_x-small"
            onClick={() => this.onIdeaSelect({ value: 'Delete' })}
          />
        </ButtonGroup>
      );
    }
    return headerActions;
  };

  getStyles = () => {
    const milestoneColors = {
      trigger: 'rgb(174, 168, 212, 1)',
      guide: '#8fcbe3',
      key: '#94c9b7',
      crisis: '#fdeab0',
      triumph: '#f092a4',
      Responsibility: '#8fcbe3',
      Pain: '#f092a4',
      Goal: '#94c9b7',
      Milestone: '#C2E8FF',
      Connector: '#CDEFC4',
    };

    const milestoneBackgrounds = {
      trigger: 'rgb(174, 168, 212, 0.4)',
      guide: 'rgb(143, 203, 227, 0.4)',
      key: 'rgb(148, 201, 183, 0.4)',
      crisis: 'rgb(253, 234, 176, 0.4)',
      triumph: 'rgb(240, 146, 164, 0.4)',
      Responsibility: 'rgb(148, 201, 183, 0.4)',
      Pain: 'rgb(240, 146, 164, 0.4)',
      Goal: 'rgb(148, 201, 183, 0.4)',
      Milestone: '#C2E8FF',
      Connector: '#CDEFC4',
    };

    const styles = {
      cardSelected: {
        boxShadow: 'rgb(60 64 67 / 20%) 0px 10.2626px 12.6834px',
        background: milestoneColors[this.props.milestone],
        borderRadius: '0',
      },
      card: {
        boxShadow: 'rgb(60 64 67 / 20%) 0px 10.2626px 13.6834px',
        background: milestoneBackgrounds[this.props.milestone],
        borderRadius: '0',
      },
      cardOutline: {
        boxShadow: 'rgb(60 64 67 / 20%) 0px 10.2626px 13.6834px',
        border: '2px solid ' + milestoneBackgrounds[this.props.milestone],
        borderRadius: '0',
        minHeight: '25px !important',
      },
      connectors: {
        boxShadow: 'rgb(60 64 67 / 20%) 0px 10.2626px 12.6834px',
        background: '#FAFFBD',
        borderRadius: '0',
      }
    };
    let style = this.props.chosen ? styles.cardSelected : styles.card;

    style = this.props.outline ? styles.cardOutline : style;

    style = this.props.connectors ? styles.connectors : style;

    return style;
  };

  render() {
    return (
      <IconSettings iconPath="/icons">
        <Card
          headerActions={!this.props.headerActions ? null : this.getHeaderActions()}
          heading={this.props.heading}
          className="slds-m-vertical_small"
          style={this.getStyles()}
        >
          <div className="slds-align_absolute-center" style={this.props.outline ? { minHeight: '0px'} : { minHeight: '60px' }}>
            <div
              className="slds-p-left_medium slds-p-bottom_xx-small"
              style={{ wordWrap: 'anywhere' }}
            >
              {this.props.ideaContent}
            </div>
          </div>
        </Card>
      </IconSettings>
    );
  }
}

export default Idea;
